import { NuvoTooltip } from '@nuvolo/nuux-core/components/NuvoTooltip';
import type { ClickEvent } from 'devextreme/ui/button';
import React, { useRef } from 'react';
import TMMButton from '../TMMButton';

export type ToolbarButtonType = 'normal' | 'danger' | 'special';
export interface ToolbarButtonProps {
  icon: string;
  onClick: (e: ClickEvent, ref?: React.RefObject<HTMLDivElement | null>) => void;
  tooltip: string;
  disabled?: boolean;
  showTextOnly?: boolean;
  type?: ToolbarButtonType;
}

const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  icon,
  onClick,
  tooltip,
  disabled,
  showTextOnly,
  type = 'normal',
}) => {
  const buttonRef = useRef<HTMLDivElement>(null);

  const btnClassNames = [];
  btnClassNames.push('nuvo-grid-toolbar-btn');
  if (showTextOnly) btnClassNames.push('nuvo-grid-toolbar-btn--text-only');
  btnClassNames.push(`nuvo-toolbar-button-${type}`);
  const buttonClassName = btnClassNames.join(' ');
  return (
    <NuvoTooltip content={tooltip}>
      <div ref={buttonRef}>
        {showTextOnly ? (
          <TMMButton
            className={buttonClassName}
            onClick={(e) => onClick(e, buttonRef)}
            label={tooltip}
            type="secondary"
            disabled={disabled}
          />
        ) : (
          <TMMButton
            className={buttonClassName}
            icon={icon}
            onClick={(e) => onClick(e, buttonRef)}
            type="secondary"
            disabled={disabled}
          />
        )}
      </div>
    </NuvoTooltip>
  );
};

export default React.memo(ToolbarButton);
